export default "__VITE_ASSET__BN5OJIVY__"